type RequestingRegistrationCodeError =
  | 'not-match'
  | 'client-existed'
  | 'already-signed-up'
  | 'duplicated';
type CreateAccountErrorCode = 'rate-limited' | 'bad-credentials';
export type RegisterError =
  | RequestingRegistrationCodeError
  | CreateAccountErrorCode
  | 'generic-error';

type RegisterStateData =
  | {
      type: 'HEALTH_AUTH';
      phoneNumber: string;
    }
  | {
      type: 'REQUESTING_REGISTRATION_CODE';
      phoneNumber: string;
      zipCode?: string;
      error?: RequestingRegistrationCodeError | 'generic-error';
    }
  | {
      type: 'CREATE_ACCOUNT';
      phoneNumber: string;
      zipCode: string;
      sfContactId: string;
      agreementTime: Date;
      error?: CreateAccountErrorCode | 'generic-error';
    }
  | {
      type: 'REGISTERED';
      phoneNumber: string;
    };

export type RegisterState = {
  data: RegisterStateData;
  loading: boolean;
};

export type RegisterAction = 'LOADING' | RegisterStateData;

export const registerReducer = (
  state: RegisterState,
  action: RegisterAction,
): RegisterState => {
  if (action === 'LOADING') {
    return { ...state, loading: true };
  } else {
    return { data: action, loading: false };
  }
};
